import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Navigation } from './Navigation';
import { Footer } from './Footer';

export function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <Navigation />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          // Ensure content doesn't stick to navigation (Fixed header is ~80px)
          pt: { xs: '100px', sm: '120px' },
          // Add minimum height to prevent footer from floating
          minHeight: 'calc(100vh - 80px - 200px)',
          '@media (min-width: 600px)': {
            minHeight: 'calc(100vh - 80px - 200px)',
          },
        }}
      >
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}